var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5008 25.7871V25.5681C15.533 24.9202 15.7406 24.2925 16.1024 23.7496C16.7045 23.0975 17.1167 22.2983 17.2957 21.436C17.2957 20.7695 17.2957 20.0935 17.3539 19.427C17.6547 16.2184 20.8273 14 23.9611 14H24.0387C27.1725 14 30.345 16.2184 30.6555 19.427C30.7137 20.0935 30.6555 20.7695 30.704 21.436C30.8854 22.3003 31.2972 23.1019 31.8974 23.7591C32.2618 24.2972 32.4698 24.9227 32.4989 25.5681V25.7776C32.5206 26.648 32.2208 27.4968 31.6548 28.1674C30.907 28.9515 29.8921 29.4393 28.8024 29.5384C25.607 29.8812 22.383 29.8812 19.1876 29.5384C18.0991 29.435 17.0858 28.9479 16.3352 28.1674C15.778 27.4963 15.4822 26.6526 15.5008 25.7871Z",
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5549 32.8518C22.0542 33.4785 22.7874 33.884 23.5922 33.9788C24.3971 34.0735 25.2072 33.8495 25.8433 33.3564C26.0389 33.2106 26.2149 33.041 26.3672 32.8518",
    stroke: "#11142D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationUser);
export default __webpack_public_path__ + "static/media/notification_user.fa9aaddb3707304be988939cc956a78a.svg";
export { ForwardRef as ReactComponent };